import { render, staticRenderFns } from "./notify-bind-account.vue?vue&type=template&id=6f66f4cc&scoped=true&"
import script from "./notify-bind-account.vue?vue&type=script&lang=js&"
export * from "./notify-bind-account.vue?vue&type=script&lang=js&"
import style0 from "./notify-bind-account.vue?vue&type=style&index=0&id=6f66f4cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f66f4cc",
  null
  
)

export default component.exports